export default __webpack_public_path__ + "static/media/1619.90715132.png";